import { T } from "../../../util/t";
import { makeStyles } from "../../../providers/makeStyles";

const useStyles = makeStyles((theme) => ({
    spotsLeft: {
        color: theme.palette.text.link,
    },
}));
export const SpotsLeft = ({ spotsLeft, includeDash, Component = "span" }) => {
    const classes = useStyles();

    return (
        <Component className={classes.spotsLeft}>
            {includeDash && <>&nbsp;-&nbsp;</>}
            {spotsLeft < 0 ? (
                <T spots={-1 * spotsLeft}>spots_over</T>
            ) : (
                <T spots={spotsLeft}>spots_left</T>
            )}
        </Component>
    );
};
